import styled from 'styled-components';
import { SideNavColorSchemeProps, SideNavColorSchemeIndex } from '../..';
import { localTheme } from '../../../../styles/local-theme';

const bgColorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.fiord,
  blue: localTheme.colors.lochmara,
};
const textColorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.iceGray,
  blue: localTheme.colors.paleBlue,
};

const SubCategoryItemDraggingPlaceholder = styled.div<SideNavColorSchemeProps>`
  display: block;
  cursor: pointer;
  border-radius: 2px;

  color: ${(props): string => textColorSchemes[props.colorScheme]};
  padding: ${(props): string => props.theme.spaces.md};
  margin: 0 -${(props): string => props.theme.spaces.md};

  background-color: ${(props): string => bgColorSchemes[props.colorScheme]};
`;

export { SubCategoryItemDraggingPlaceholder };
